import "./BlogCard.scss";
import { FiClock } from "react-icons/fi";
import { FaRegCircleUser } from "react-icons/fa6";
import Btn from "../btn/Btn";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../../utils/apiData";

const BlogCard = ({ data }) => {
  const navigate = useNavigate();

  function formatDate(dateString) {
    const date = new Date(dateString);

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }
  return (
    <motion.div
      initial={{ translateY: 32, opacity: 0 }}
      whileInView={{ translateY: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: "easeInOut" }}
      viewport={{ once: true }}
      className="blog_card"
    >
      <div className="img_wrap">
        <img src={`${baseUrl}/${data?.image}`} alt="Blog" />
      </div>
      <div className="detail">
      <div className="info_line">
        <div className="info">
          <FaRegCircleUser /> <p>{data?.author}</p>
        </div>
        <div className="info">
          <FiClock /> <p>{formatDate(data?.createdAt)}</p>
        </div>
      </div>
      <h3>{data?.name}</h3>
      <p>{data?.main_title}</p>
      <Btn title="Read More" onClick={() => navigate(`/blogs/${data?.slug}`)} />
      </div>
    </motion.div>
  );
};

export default BlogCard;
